import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { SigedCommonService } from "../siged-common.service";
import { AuthService } from './auth.service';

@Injectable({
    providedIn: 'root'
})

export class DescargarArchivo {
    private baseUrl = this.mpvCommonService.APPLICATION_API_HOST;

    private defaultHeaders;

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        public mpvCommonService: SigedCommonService,
    ) {
        this.defaultHeaders = {
            Authorization: 'Bearer ' + this.authService.getUser()
        }
    }

    getUrlSinSello() {
        return `${this.baseUrl}/alfresco/downloadSinSello`
    }

    getUrlByUUID(uuid: string) {
        return `${this.baseUrl}/alfresco/download/${uuid}`
    }

    getUrlByUUIDWhiteMark(uuid: string, nombreArchivo: string) {
        return `${this.baseUrl}/alfresco/getFileWatermark?uuid=${uuid}&nombreArchivo=${nombreArchivo}`
    }

    getUrlByUUIDWithoutToken(uuid: string) {
        return `${this.baseUrl}/alfresco/downloadSeguridad/${uuid}`
    }

    getUrlByUUIDMPV(uuid: string) {
        return `${this.baseUrl}/alfresco/downloadMPV/${uuid}`
    }

    getUrlByUUIDArchivo(uuid: string) {
        return `${this.baseUrl}/alfresco/downloadAlfrescoArchivo/${uuid}`
    }

    getFullURLDownload(uuid) {
        let a = uuid.split(';');
        let alfresoUUID = a[0];
        this.http.get(this.getUrlByUUID(alfresoUUID), {headers: this.defaultHeaders})
            .toPromise()
            .then((res: any) => {
                console.log(res.mensaje)
                window.open(res.mensaje);
            })
    }

    getFullURLDownloadSinSello(uuid, motivo, idPersona) {     

        const payload = {
            uuid: uuid,
            motivo: motivo,
            idPersona: idPersona
        };
        this.http.post(this.getUrlSinSello(), payload, {headers: this.defaultHeaders})
            .toPromise()
            .then((res: any) => {
                console.log(res)
                if (res.estado != 1) {
                     Swal.fire({
                        icon: 'warning',
                        title: 'Acceso restringido',
                        text: res.mensaje
                    })
                }else {
                    window.open(res.mensaje);
                }
            })
    }

    getFullURLDownloadArchivo(uuid) {
        let a = uuid.split(';');
        let alfresoUUID = a[0];
        this.http.get(this.getUrlByUUIDArchivo(alfresoUUID), {headers: this.defaultHeaders})
            .toPromise()
            .then((res: any) => {
                console.log(res.mensaje)
                window.open(res.mensaje);
            })
    }

    getFullURLDownloadWithoutToken(uuid) {
        let a = uuid.split(';');
        let alfresoUUID = a[0];
        this.http.get(this.getUrlByUUIDWithoutToken(alfresoUUID))
            .toPromise()
            .then((res: any) => {
                console.log(res.mensaje)
                window.open(res.mensaje);
            })
    }

    getFullURLDownloadMPV(uuid) {
        let a = uuid.split(';');
        let alfresoUUID = a[0];
        this.http.get(this.getUrlByUUIDMPV(alfresoUUID), {headers: this.defaultHeaders})
            .toPromise()
            .then((res: any) => {
                console.log(res.mensaje)
                window.open(res.mensaje);
            })
    }

    downloadFileByVersion(idVersionFile: string, nombreArchivo: string) {
        this.http.get(`${this.baseUrl}/alfresco/download/version/${idVersionFile}`, {
            headers: this.defaultHeaders,
            responseType: 'blob' // Importante: especificar que esperamos un blob
        }).subscribe({
            next: (blob: Blob) => {
                // Crear un URL temporal para el blob
                const url = window.URL.createObjectURL(blob);

                // Crear un elemento anchor temporal
                const link = document.createElement('a');
                link.href = url;
                link.download = nombreArchivo; // Fuerza la descarga con este nombre
                link.style.display = 'none'; // Ocultamos el enlace

                // Agregar el enlace al DOM temporalmente
                document.body.appendChild(link);

                // Hacer click programáticamente para iniciar la descarga
                link.click();

                // Limpiar: remover el enlace y liberar el URL del blob
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);

                console.log(`Archivo ${nombreArchivo} descargado exitosamente`);
            },
            error: (error) => {
                console.error('Error al descargar el archivo:', error);
                // Aquí puedes agregar manejo de errores adicional
            }
        });
    }

    descargarArchivoSistram(
        uuid: string,
        nombreArchivo: string,
        headers?: HttpHeaders | { [header: string]: string | string[]; }
    ) {
        const url = `${this.baseUrl}/alfresco/downloadSistram?uuid=${uuid}&nombreArchivo=${nombreArchivo}`;
        const options = {headers: {...this.defaultHeaders, ...headers}}
        return this.http.get(url, options).toPromise();
    }
 
    descargarArchivoWhiteMark(uuid: string, nombreArchivo: string) {
        // Configuramos el responseType como 'blob' para recibir el archivo
        this.http.get(`${this.baseUrl}/alfresco/getFileWatermark?uuid=${uuid}&nombreArchivo=${nombreArchivo}`, {
            headers: this.defaultHeaders,
            responseType: 'blob' // Importante: especificar que esperamos un blob
        }).subscribe({
            next: (blob: Blob) => {
                // Crear un URL temporal para el blob
                const url = window.URL.createObjectURL(blob);
                
                // Crear un elemento anchor temporal
                const link = document.createElement('a');
                link.href = url;
                link.download = nombreArchivo; // Fuerza la descarga con este nombre
                link.style.display = 'none'; // Ocultamos el enlace
                
                // Agregar el enlace al DOM temporalmente
                document.body.appendChild(link);
                
                // Hacer click programáticamente para iniciar la descarga
                link.click();
                
                // Limpiar: remover el enlace y liberar el URL del blob
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
                
                console.log(`Archivo ${nombreArchivo} descargado exitosamente`);
            },
            error: (error) => {
                console.error('Error al descargar el archivo:', error);
                // Aquí puedes agregar manejo de errores adicional
            }
        });
    }

}
